import { Button, Container, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ConfirmContentProps {
  onSaveClick: (data?: any) => void;
  onDiscardClick: () => void;
  dialogTitle?: string;
}

const ConfirmContent = (props: ConfirmContentProps) => {
  const { onSaveClick, onDiscardClick, dialogTitle } = props;
  const { t } = useTranslation();
  return (
    <>
      <DialogTitle
        variant="h4"
        sx={{
          textAlign: 'center',
          marginTop: '1rem',
        }}
      >
        {dialogTitle ? t(dialogTitle) : t('confirm_dialog.message')}
      </DialogTitle>
      <Container
        sx={{
          marginBottom: '1rem',
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
        }}
      >
        <Button
          variant="outlined"
          color="primary"
          sx={{ paddingY: '0.5rem', paddingX: '2rem' }}
          onClick={onDiscardClick}
        >
          {t('confirm_dialog.discard')}
        </Button>
        <Button
          onClick={onSaveClick}
          variant="contained"
          color="primary"
          sx={{ paddingY: '0.5rem', paddingX: '2rem' }}
        >
          {t('confirm_dialog.confirm')}
        </Button>
      </Container>
    </>
  );
};

export default ConfirmContent;
